import { List, Map } from 'immutable';

import { getUserFeatures, isInfluencer } from './features';
import { toCamelCase } from './string';
import { isObject } from './isObject';
import { reduce } from './iterable/reduce';

import { FEATURE } from '../constants/features';
import { EMPTY } from '../constants';
import { PLAN } from '../constants/billingV3';

export function shapeBetaAccessForApp({ subscriptions }) {
  function reduceSubscriptions(result, subscription) {
    return result.set(subscription.feature, subscription.id);
  }

  return subscriptions.reduce(reduceSubscriptions, EMPTY.MAP);
}

export function shapeSubscriptionsForApp({ subscriptions, user }) {
  function reduceSubscriptions(result, subscription, shopId) {
    return (
      !user.getIn(['features', FEATURE.BILLING_V3]) ||
      subscription.plan === PLAN.FREE ||
      !isInfluencer(user.get('userId'))
    )
      ? result.set(shopId, Map(subscription))
      : result.set(shopId, Map({ frozen: true, plan: PLAN.PLUS }));
  }

  return reduce(subscriptions, EMPTY.MAP, reduceSubscriptions);
}

export function shapeUserDataForApp({ data, user }) {
  function reduceUserData(result, value, key) {
    if (key === 'last_seen_shop') return result;

    function addValue(shapedValue) {
      return List.isList(result)
        ? result.push(shapedValue)
        : result.set(toCamelCase(key), shapedValue);
    }

    if (Array.isArray(value)) {
      return addValue(value.reduce(reduceUserData, EMPTY.LIST));
    } else if (isObject(value)) {
      return addValue(reduce(value, EMPTY.MAP, reduceUserData));
    } else {
      return addValue(value);
    }
  }

  return reduce(data, user.set('features', getUserFeatures(data.user_id)), reduceUserData);
}

export function setUserLoaded(state) {
  const loaded = (
    state.hasIn(['user', 'subscriptions']) &&
    state.hasIn(['user', 'userId'])
  );

  return state.setIn(['user', 'loaded'], loaded);
}
